import React, { useState, useEffect, useRef } from 'react';
import avatarDefault from '../../../assets/images/user-illustarator-2.png'; // Import your default avatar image
import { fetchAvatarList,baseURL } from '../../../utils/usermanagement'; // Import your API function for fetching avatars
function AvatarSelector({ onSelect, onClose }) {
  const [selectedAvatarId, setSelectedAvatarId] = useState(null);
  const [selectedPetAvatarId, setSelectedPetAvatarId] = useState(null);
  const [isAutoScrolling, setIsAutoScrolling] = useState(true);
  const [avatars, setAvatars] = useState([]);
  const [petAvatars, setPetAvatars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const avatarScrollRef = useRef(null);

  // Safe function wrapper to prevent undefined errors
  const safeCall = (fn, ...args) => {
    try {
      if (typeof fn === 'function') {
        return fn(...args);
      }
    } catch (error) {
      console.error('Error in safe function call:', error);
      setError('An error occurred. Please try again.');
    }
  };
  
  // Fetch avatars from backend
  useEffect(() => {
    // Simulate fetching data from backend
    const fetchAvatars = async () => {
      try {
        // In a real application, this would be replaced with an actual API call
         const response = await fetchAvatarList();
        // const data = await response.json();
        if(response.status==200){
          setAvatars(response.data.profile_photos);  
          setPetAvatars(response.data.pet_profile_photos);  
          setLoading(false);
        }else{
          setLoading(false);
        }
        // Mock data for demonstration
        // const mockAvatars = Array.from({ length: 18 }, (_, i) => ({
        //   id: i + 1,
        //   imageUrl: `/api/placeholder/100/100`, // Using placeholder images for demo
        //   // In a real app you would use your backend image URLs:
        //   // imageUrl: `https://your-backend.com/avatars/${i + 1}.png`
        // }));
        
        // // Simulate network delay
        // setTimeout(() => {
        //   setAvatars(mockAvatars);
        //   setLoading(false);
        // }, 800);
      } catch (error) {
        console.error("Error fetching avatars:", error);
        setError('Failed to load avatars. Please refresh and try again.');
        setLoading(false);
      }
    };
    
    fetchAvatars();
  }, []);

  // Auto-scrolling effect
 
 

  const handleAvatarSelect = (id) => {
    try {
      setSelectedAvatarId(id);
      setIsAutoScrolling(false);
    } catch (error) {
      console.error('Error selecting avatar:', error);
      setError('Failed to select avatar. Please try again.');
    }
  };
  
  const handlePetAvatarSelect = (id) => {
    try {
      setSelectedPetAvatarId(id);
      setIsAutoScrolling(false);
    } catch (error) {
      console.error('Error selecting pet avatar:', error);
      setError('Failed to select pet avatar. Please try again.');
    }
  };

  const handleApply = () => {
    try {
      if (selectedAvatarId) { 
        safeCall(onSelect, selectedAvatarId, selectedPetAvatarId);
      }
    } catch (error) {
      console.error('Error applying avatar selection:', error);
      setError('Failed to apply selection. Please try again.');
    }
  };

 

  // Sub-component: AvatarGrid
  const AvatarGrid = () => {
    return (
      <div className="avatar-grid">
        {avatars.map(avatar => (
          <div 
            key={avatar}
            className={`avatar-item ${avatar === selectedAvatarId ? 'selected' : ''}`}
            onClick={() => handleAvatarSelect(avatar)}
          >
            <div className="avatar-circle">
              <img 
                src={ avatar ? `${baseURL}/file/avatar/`+avatar : avatarDefault} 
                alt={`Avatar ${avatar}`} 
                className="avatar-image"
                loading="lazy"
              />
            </div>
          </div> 
        ))}
      </div>
    );
  };

 
  const PetAvatarGrid = () => {
    return (
      <div className="avatar-grid">
        {petAvatars.map(avatar => (
          <div 
            key={avatar}
            className={`avatar-item ${avatar === selectedPetAvatarId ? 'selected' : ''}`}
            onClick={() => handlePetAvatarSelect(avatar)}
          >
            <div className="avatar-circle">
              <img 
                src={ avatar ? `${baseURL}/file/avatar/pet/`+avatar : avatarDefault} 
                alt={`Avatar ${avatar}`} 
                className="avatar-image"
                loading="lazy"
              />
            </div>
          </div> 
        ))}
      </div>
    );
  };

  return (
    <div className="avatar-app" style={{ 
      width: '100%',  
      padding: '0',
      display: 'flex',
      background: 'white',
      flexDirection: 'column',
      zIndex: '1000',
    }}>
      <style jsx>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        
        .avatar-app {
          background-color: #f5f5f5;
          display: flex;
          justify-content: center;
          align-items: center;  
        } 
        
        .header {
          background-color: #2dd4bf;
          color: white;
          padding: 20px 30px;
          text-align: center;
          width: 100%;
        }
        
        .header h1 {
          font-size: 28px;
          font-weight: 600;
          margin-bottom: 6px;
        }
        
        .header p {
          font-size: 16px;
          opacity: 0.9;
        }
        
        .avatar-container {
          padding: 20px;
          display: flex;
          flex-direction: column;
          gap: 20px;
          overflow-y: auto;
          height: 70vh;
           /* 新增绿色滚动条样式 */
          &::-webkit-scrollbar {
            width: 8px;
          }
          &::-webkit-scrollbar-track {
            background: #e0fffa;
            border-radius: 4px;
          }
          &::-webkit-scrollbar-thumb {
            background-color: #2dd4bf;
            border-radius: 8px;
            border: 2px solid #e0fffa;
          }
        }
        
        .avatar-scroll {
          height: 450px;
          position: relative; 
          padding: 10px;
          background-color: #f0fffc;
          border-radius: 15px;
        }
        
        .avatar-grid {
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          gap: 20px;
          padding: 10px;
        }
        
        .avatar-item {
          cursor: pointer;
          position: relative;
          transition: transform 0.2s;
        }
        
        .avatar-item:hover {
          transform: scale(1.05);
        }
        
        .avatar-circle {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background-color: #e0e0e0;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          overflow: hidden;
          position: relative;
          transition: all 0.3s;
        }
        
        .avatar-image { 
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
        
        .selected .avatar-circle {
          box-shadow: 0 0 0 4px #2dd4bf, 0 0 0 6px rgba(45, 212, 191, 0.3);
        }
        
        .avatar-footer {
          padding: 0 20px 30px 30px;
          text-align: center;
          background-color: white;
        }
        
        .apply-button {
          background-color: #2dd4bf;
          color: white;
          border: none;
          padding: 14px 30px;
          font-size: 16px;
          font-weight: 600;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s;
          width: 200px;
        }
        
        .apply-button:hover {
          background-color: #0faa96;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(45, 212, 191, 0.3);
        }
        
        .apply-button:disabled {
          background-color: #e0e0e0;
          color: #a0a0a0;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }
        
        .footer-text {
          margin-bottom: 20px;
          font-size: 14px;
          color: #666;
        }
        
        /* Loading styles */
        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          color: #2dd4bf;
          gap: 15px;
        }
        
        .loading-spinner {
          width: 50px;
          height: 50px;
          border: 4px solid rgba(45, 212, 191, 0.2);
          border-top: 4px solid #2dd4bf;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        
      
        /* Responsive adjustments */
        @media (max-width: 920px) {
          .container {
            width: 100%;
          }
          
          .avatar-grid {
            grid-template-columns: repeat(4, 1fr);
          }
        }
        
        @media (max-width: 640px) {
          .avatar-grid {
            grid-template-columns: repeat(3, 1fr);
          }
          
          .avatar-circle {
            width: 80px;
            height: 80px;
          }
        }
      `}</style>
 
        <div className="header">
          <h1>Choose a default avatar</h1>
          <p>Select an avatar to personalize your profile</p>
        </div>
        
        <div className="avatar-container">
          <div 
            className="avatar-scroll"  
          >
            {error ? (
              <div className="loading-container">
                <div className="alert alert-danger">
                  <h5>Error</h5>
                  <p>{error}</p>
                  <button 
                    className="btn btn-primary btn-sm"
                    onClick={() => {
                      setError(null);
                      setLoading(true);
                      // Retry loading
                      window.location.reload();
                    }}
                  >
                    Retry
                  </button>
                </div>
              </div>
            ) : loading ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Loading avatars...</p>
              </div>
            ) : (
              <>
              <h3>Avatar</h3>
              <AvatarGrid 
                avatars={avatars} 
                selectedAvatarId={selectedAvatarId}
                onSelectAvatar={handleAvatarSelect}
              />
              
              <h3>Pet</h3>
              <PetAvatarGrid 
                avatars={petAvatars} 
                selectedAvatarId={selectedPetAvatarId}
                onSelectAvatar={handlePetAvatarSelect}
              />
              </>
              
            )}
          </div>
         
         <div className="avatar-footer">
            <p>Choose a default avatar to get started.</p>
            <p className="footer-text">You can change the way it looks after!</p>
            <button 
              className="apply-button" 
              disabled={!selectedAvatarId}
              onClick={handleApply}
            >
              APPLY
            </button>
          </div>
        </div>
      </div>
 
  );
}

export default AvatarSelector;